import React from 'react';
import classNames from 'classnames';
// import Modal from '../../../design-system/components/atoms/modal';
import DataTable from '../../data-table/data-table';
import { FactorDetailsModalProps } from '../types';
import Modal from '../../../design-system/ui/modal';


const FactorDetailsModal: React.FC<FactorDetailsModalProps> = ({
  show,
  onClose,
  factorModalConfig
}) => {

  const handleClose = () => {
    onClose();
  };

  const hasValidData = Array.isArray(factorModalConfig?.columns) && Array.isArray(factorModalConfig?.data);

  const modalClassName = classNames([
    'factor-details-modal',
    {
      'factor-details-modal-small': factorModalConfig?.width === 'small',
    },
  ]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      title={factorModalConfig?.title}
      showCloseButton={!!factorModalConfig?.footer || hasValidData}
      className={modalClassName}
      primaryBtnLabel="Close"
      hideSecondaryBtn={true}
      hidePrimaryBtn={!!factorModalConfig?.footer || hasValidData}
      hideFooter={hasValidData && !factorModalConfig?.footer}
      footer={factorModalConfig?.footer}
      primaryBtnClickedHandler={handleClose}
    >
      <div>
        {factorModalConfig?.content && (
          <div className={hasValidData ? 'factor-modal-content' : ''}>
            {factorModalConfig?.content}
          </div>
        )}

        {hasValidData && (
          <DataTable 
            columns={factorModalConfig.columns}
            data={factorModalConfig.data}
          />
        )}
      </div>
    </Modal>
  );
};

export default FactorDetailsModal; 